import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import scheduleImg1 from '../../assets/images/resources/schedule-one-1-1.jpg';

const EventItem = React.memo(function EventItem({
  id,
  titulo,
  subtitulo,
  descripcion,
  facebook,
  instagram,
  tiktok,
  imagenPremium0,
  fechahora,
  direccion,
  premium,
  enlace,
  contactocell,
  fuente,
  geo
}) {
  const descripcionFinal = (descripcion.length > 500) ? descripcion.slice(0, 500) + "..." : descripcion;

  return (
    <div className="schedule-one__single" key={'div-' + id + '-' + fechahora.toMillis()}>
      <div className="schedule-one__left">
        <h3 className="schedule-one__title">
          <Link to={enlace || "#"} target="blank" rel="noopener noreferrer">
            <span className="time-military">
              {fechahora.toDate().toLocaleTimeString('es-EC', {
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
              })}
            </span>
            {" "}
            {titulo || "Título no disponible"} <br />
            {subtitulo || ""}
          </Link>
        </h3>
        <p className="schedule-one__text">
          {(descripcionFinal || "Descripción no disponible.")
            .split('<br>')
            .map((parte, index, partes) => (
              <React.Fragment key={'fragment-' + index}>
                {parte}
                {index < partes.length - 1 && <br />}
              </React.Fragment>
            ))}{(descripcion.length > 500) && <Link to={enlace || "#"} target="_blank" rel="noopener noreferrer"> Leer más </Link>}
        </p>
        <br />
        <p>
          {facebook && (
            <a href={facebook} className="icon-social" target="_blank" rel="noopener noreferrer">
              <span className="icon-facebook"> </span>
            </a>
          )}
          {instagram && (
            <a href={instagram} className="icon-social" target="_blank" rel="noopener noreferrer">
              <span className="icon-instagram"></span>
            </a>
          )}
          {tiktok && (
            <a href={tiktok} className="icon-social" target="_blank" rel="noopener noreferrer">
              <span className="icon-star"> </span>
            </a>
          )}
        </p>
      </div>
      <div className="schedule-one__img">
        <img src={imagenPremium0 || scheduleImg1} alt="" />
      </div>
      <div className="schedule-one__address-and-btn-box">
        <ul className="list-unstyled schedule-one__address">
          <li>
            <div className="icon">
              <span className="icon-clock"></span>
            </div>
            <div className="text">
              <p>
                {fechahora.toDate().toLocaleDateString('es-ES', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                })}
                <br />
                {fechahora.toDate().toLocaleTimeString('es-EC', {
                  hour: '2-digit',
                  minute: '2-digit'
                })}
              </p>
            </div>
          </li>
          <li>
            <div className="icon">
              <span className="icon-pin"></span>
            </div>
            {direccion &&
              <div className="text cartelera-div_direccion">
                <p>
                  <Link to={'https://www.google.com/maps?q=' + (geo || direccion)} target="_blank" rel="noopener noreferrer">
                    {direccion || "Dirección no disponible."
                      .split('<br>')
                      .map((parte, index, partes) => (
                        <React.Fragment key={index}>
                          {parte}
                          {index < partes.length - 1 && <br />}
                        </React.Fragment>
                      ))}
                  </Link>
                </p>
              </div>
            }
          </li>
          {fuente &&
            <li>
              <div className="icon">
                <span className="icon-loupe"></span>
              </div>
              <div className="text">
                <p>
                  {'  Fuente: ' + fuente}
                </p>
              </div>
            </li>
          }
          <li>
            <div className="schedule-one__btn-box">
              <Link
                to={premium === 3 ? '/event-details/' + id : enlace || "tel:" + contactocell}
                className="schedule-one__btn thm-btn"
                target='_blank'
                rel="noopener noreferrer"
              >
                Reservar
                <span className="icon-arrow-right"></span>
              </Link>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
});

export default EventItem;
